import { useEffect, useRef, useState } from "react";

// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import facebookIcon from "assets/svg/FacebookGrey.svg";
import linkedInIcon from "assets/svg/LinkedInGrey.svg";
import ArrowUpIcon from "assets/svg/RightRedIcon.svg";
import shareIcon from "assets/svg/ShareIcon.svg";
import calendarIcon from "assets/svg/data.svg";

// STYLES
import {
  BackOnTopImg,
  BackOnTopWrapper,
  BackToButton,
  BackToImage,
  BackToWrapper,
  Body,
  ButtonWrapper,
  CenterCardTitle,
  ContentCard,
  ContentLeftCard,
  CopyToClipboardTooltip,
  CopyToClipboardWrapper,
  DetailsOtherEventsWrapper,
  DetailsSection,
  FirstColumn,
  HeaderImage,
  HeaderImageWrapper,
  ImgLeftSection,
  ImgStyled,
  InsideFirstColumn,
  InsideThirdColumn,
  LeftCard,
  NewsAndPartnersDetailsContainer,
  OtherCampaignsContent,
  OtherChapters,
  OtherGuidesCard,
  ScrollTargetWrapper,
  SecondColumn,
  SectionsLeftCard,
  SkeletonWrapperChapter,
  SkeletonWrapperOtherChapter,
  SocialMediaCard,
  SocialMediaIcon,
  SocialMediaIcons,
  ThirdColumn,
  TitleLeftCard,
  TitleWrapper,
} from "./CampaignDetailsStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { FacebookShareButton, LinkedinShareButton } from "react-share";

// MISC

import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { appRoutes } from "config/AppRoutesConfig";
import { carouselCards } from "constants/mocks/Officials";
import { content } from "constants/mocks/ProjectData";
import { BORDER_RADIUS, COLORS, DEVICE_TYPE } from "constants/variables";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import CustomText from "components/Atoms/CustomText/CustomText";
import StrapiTreeText from "components/Atoms/StrapiTreeText/StrapiTreeText";
import OfficialsCarousel from "components/OfficialsCarousel/OfficialsCarousel";
import { uploadBaseUrl } from "services/base";
import mapService from "services/mapService";
import { CampaignData } from "./CampaignDetailsModel";
import { secondUploadBaseUrl } from "services/helperBase";
import formatDateToRomanian from "utils/formatDateToRomanian";

const CampaignDetails = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: DEVICE_TYPE.mobileHeader });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { id } = useParams<{ id: string }>(); // Extract the id from the route params

  // STATE CONSTANTS

  // STATE CONSTANTS

  const contentRefs = useRef([]);
  const [copied, setCopied] = useState(false);
  const [campaign, setCampaign] = useState<CampaignData>();
  const [otherCampaigns, setOtherCampaigns] = useState<any>();
  const headerImageWrapperRef = useRef(null);
  const skeletonCount = 3;

  // EVENT HANDLERS

  useEffect(() => {
    // setLoading(true);
    mapService
      .getCampaign(id)
      .then((response) => {
        // console.log("getCampaign resp", response);
        setCampaign(response.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
    mapService
      .getCampaigns()
      .then((response) => {
        // console.log("getCampaign resp", response);
        setOtherCampaigns(response.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, [id]);

  const scrollToTop = () => {
    if (headerImageWrapperRef.current) {
      headerImageWrapperRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => console.error("Failed to copy URL: ", err));
  };

  return (
    <NewsAndPartnersDetailsContainer>
      <HeaderImageWrapper ref={headerImageWrapperRef}>
        <HeaderImage
          src={
            campaign?.attributes?.cover?.data?.attributes?.url?.trim()
              ? `${secondUploadBaseUrl}${campaign?.attributes?.cover?.data?.attributes?.url}`
              : CoverPlaceholder
          }
          loading="lazy" decoding="async"
          alt={"coverGuideImage"}
        />
      </HeaderImageWrapper>
      <Body>
        <FirstColumn>
          <InsideFirstColumn>
            <BackToWrapper
              onClick={() => navigate(appRoutes.dialog)}
              biggerCursor={biggerCursor}
            >
              <BackToImage src={LeftArrow} alt="backIcon" />
              <BackToButton biggerCursor={biggerCursor}>
                <CustomText
                  text={t("view.campaignDetails.events")}
                  type={TextType.H5boldspaced}
                  color={COLORS.RaisinBlack}
                />
              </BackToButton>
            </BackToWrapper>
            <TitleWrapper>
              <CustomText
                text={campaign?.attributes?.title}
                type={TextType.H3}
              />
            </TitleWrapper>
            {/* <PartnerWrapper>
              <ImgPartner src={
    campaign?.attributes?.partener_logo?.data?.attributes?.url?.trim()
      ? `${uploadBaseUrl}${campaign?.attributes?.partener_logo?.data?.attributes?.url}`
      : CoverPlaceholder
  } />
              <CustomText
                text={campaign?.attributes?.partener}
                type={TextType.H4}
                color={COLORS.MetalicSilver}
              />
            </PartnerWrapper> */}
            <LeftCard>
              <TitleLeftCard>
                <CustomText
                  text={t("view.campaignDetails.dateEvent")}
                  type={TextType.H3}
                />
              </TitleLeftCard>
              <ContentLeftCard>
                <SectionsLeftCard>
                  <CustomText
                    text={t("view.campaignDetails.dateAndHour")}
                    type={TextType.H4}
                    color={COLORS.MetalicSilver}
                  />
                  <DetailsSection>
                    <ImgLeftSection src={calendarIcon} />
                    <CustomText
                      text={`${formatDateToRomanian(
                        campaign?.attributes?.publishedAt
                      )}`}
                      type={TextType.P1}
                    />
                  </DetailsSection>
                </SectionsLeftCard>
                <SectionsLeftCard>
                  {/* <CustomText
                    text={t("view.detailsEvents.location")}
                    type={TextType.H4}
                    color={COLORS.MetalicSilver}
                  /> */}
                  {/* <DetailsSection>
                    <ImgLeftSection src={locationIcon} />
                    <CustomText
                      text={`${campaign?.attributes?.address}, ${campaign?.attributes?.city}`}
                      type={TextType.P1}
                    />
                  </DetailsSection> */}
                </SectionsLeftCard>
                <SectionsLeftCard>
                  {/* <CustomText
                    text={t("view.detailsEvents.contact")}
                    type={TextType.H4}
                    color={COLORS.MetalicSilver}
                  /> */}
                  {/* <DetailsSection>
                    <ImgLeftSection src={PhoneIcon} />
                    <CustomText text={campaign?.attributes?.phone} type={TextType.P1} />
                  </DetailsSection> */}
                  {/* <DetailsSection>
                    <ImgLeftSection src={mailIcon} />
                    <CustomText
                      text={campaign?.attributes?.email}
                      type={TextType.P1}
                    />
                  </DetailsSection> */}
                  {/* <DetailsSection>
                    <ImgLeftSection src={webSiteIcon} />
                    <CustomText text={campaign?.attributes?.website} type={TextType.P1} />
                  </DetailsSection> */}
                </SectionsLeftCard>
              </ContentLeftCard>
            </LeftCard>
          </InsideFirstColumn>
        </FirstColumn>
        <SecondColumn>
          {campaign?.attributes?.content ? (
            <ScrollTargetWrapper
              ref={contentRefs.current[0]}
              // key={index}
              id={campaign?.id}
            >
              <ContentCard tabIndex={0}>
                <CenterCardTitle>
                  {/* <CustomText text={event?.attributes?.event_chapters?.data[0]?.attributes?.title} type={TextType.H3} /> */}
                </CenterCardTitle>
                <StrapiTreeText text={campaign?.attributes?.content} />
              </ContentCard>
            </ScrollTargetWrapper>
          ) : (
            <ContentCard tabIndex={0}>
              <Skeleton
                width={"100%"}
                count={105}
                baseColor={COLORS.Background}
                highlightColor={COLORS.Cultured}
              />
            </ContentCard>
          )}
        </SecondColumn>
        <ThirdColumn>
          <InsideThirdColumn>
            <SocialMediaCard>
              <CustomText
                text={"SHARE"}
                type={TextType.H5}
                color={COLORS.Yellow}
              />
              <SocialMediaIcons>
                <FacebookShareButton url={window.location.href}>
                  <SocialMediaIcon
                    src={facebookIcon}
                    alt="facebookIcon"
                    biggerCursor={biggerCursor}
                  />
                </FacebookShareButton>
                <LinkedinShareButton url={window.location.href}>
                  <SocialMediaIcon
                    src={linkedInIcon}
                    alt="linkedInIcon"
                    biggerCursor={biggerCursor}
                  />
                </LinkedinShareButton>
                <CopyToClipboardWrapper onClick={handleCopyToClipboard}>
                  <SocialMediaIcon
                    src={shareIcon}
                    alt="shareIcon"
                    biggerCursor={biggerCursor}
                  />
                  {copied && (
                    <CopyToClipboardTooltip>
                      <CustomText
                        text={t(
                          "view.newsAndMedia.officialAnnouncementsDetails.copyClipboard"
                        )}
                        type={TextType.P2}
                        color={COLORS.RaisinBlack}
                      />
                    </CopyToClipboardTooltip>
                  )}
                </CopyToClipboardWrapper>
              </SocialMediaIcons>
            </SocialMediaCard>
            <OtherGuidesCard>
              <CustomText
                text={t("view.campaignDetails.otherEvents")}
                type={TextType.H3}
              />
              {otherCampaigns?.length > 0 ? (
                otherCampaigns
                  .filter((campaign: any) => campaign?.id !== Number(id))
                  .slice(0, 3)
                  .map((campaign: any, index: number) => (
                    <OtherChapters key={index} biggerCursor={biggerCursor}>
                      <ImgStyled
                        src={
                          campaign?.attributes?.cover?.data?.attributes?.url?.trim()
                            ? `${secondUploadBaseUrl}${campaign?.attributes?.cover?.data?.attributes?.url}`
                            : CoverPlaceholder
                        }
                        alt={"imageOthercampaigns"}
                        loading="lazy" decoding="async"
                        onClick={() =>
                          navigate(appRoutes.campaignsDetails + campaign?.id)
                        }
                      />
                      <DetailsOtherEventsWrapper>
                        <OtherCampaignsContent
                          onClick={() =>
                            navigate(appRoutes.campaignsDetails + campaign?.id)
                          }
                        >
                          <CustomText
                            text={campaign?.attributes?.title}
                            type={TextType.H4officials}
                          />
                        </OtherCampaignsContent>
                        <CustomText
                          text={`${formatDateToRomanian(
                            campaign?.attributes?.publishedAt
                          )}`}
                          type={TextType.P2}
                          color={COLORS.MetalicSilver}
                        />
                      </DetailsOtherEventsWrapper>
                    </OtherChapters>
                  ))
              ) : (
                <>
                  {[...Array(skeletonCount)].map((_, index) => (
                    <SkeletonWrapperOtherChapter key={index}>
                      <Skeleton
                        width={"80px"}
                        height={"80px"}
                        borderRadius={BORDER_RADIUS.radius16}
                        baseColor={COLORS.Background}
                        highlightColor={COLORS.Cultured}
                      />
                      <SkeletonWrapperChapter>
                        <Skeleton
                          count={1}
                          baseColor={COLORS.Background}
                          highlightColor={COLORS.Cultured}
                        />
                      </SkeletonWrapperChapter>
                    </SkeletonWrapperOtherChapter>
                  ))}
                </>
              )}
            </OtherGuidesCard>

            {/* <OtherGuidesCard>
              <CustomText
                text={t("view.campaignDetails.access")}
                type={TextType.H3}
              />
              <CustomText
                text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit"}
                type={TextType.P2}
              />
              <ButtonWrapper>
                <ButtonAtom
                  type={ButtonType.RedButton}
                  text={t("view.detailsEvents.mapEvents")}
                  hasArrow={true}
                  onClick={() => console.log("CLICKED")}
                />
              </ButtonWrapper>
            </OtherGuidesCard> */}
          </InsideThirdColumn>
        </ThirdColumn>
      </Body>
      {/* <OfficialsCarousel data={carouselCards} /> */}
      {isMobile && (
        <BackOnTopWrapper onClick={scrollToTop}>
          <BackOnTopImg src={ArrowUpIcon} alt="ArrowUpIcon" />
        </BackOnTopWrapper>
      )}
    </NewsAndPartnersDetailsContainer>
  );
};

export default CampaignDetails;
